import React, { useContext, useEffect, useState } from 'react'
import { policy_details, policy_update } from '../api/api'
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';
import Loader from '../Loader/Loader';
import { MyContext } from '../context/Context';
import { Link } from 'react-router-dom';
import TextEditor from '../components/TextEditor';
import { toast } from 'react-toastify';

const PrivacyPolicy = () => {
    const [policy, setPolicy] = useState("");
    console.log(policy)

    const { loader, setLoader } = useContext(MyContext);
    const getPolicyDetails = async () => {
        setLoader(true);
        try {
            const { data } = await policy_details({
                slug: 'privacy-policy',
            });
            if (data.status === 200 && data.data.length > 0) {
                setPolicy(data.data[0]?.body);
            }
        } catch (error) {
            console.error('Policy details error', error);
        } finally {
            setLoader(false);
        }
    }
    useEffect(() => {
        getPolicyDetails();
    }, []);
    const updatePolicyDetails = async () => {
        setLoader(true);
        try {
            const response = await policy_update({
                title: 'Privacy Policy',
                slug: 'privacy-policy',
                body: policy
            });
            if (response.status === 200) {
                setLoader(false);
                toast.success('Policy updated successfully');
            }
        } catch (error) {
            console.error('Policy update error', error);
        }
    }

    return (
        <div className="wrapper">
            <Navbar />
            <Sidebar />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12 d-flex flex-column flex-sm-row justify-content-between">
                                <h1 className="m-0">Privacy Policy</h1>
                                <span className='text-sm d-flex justify-content-end mt-4 mb-4 mt-sm-0 mb-sm-0'>
                                    <Link to="/dashboard">Dashboard</Link>
                                    <span className='ml-1 mr-1'>/</span>
                                    <span>Privacy Policy</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>


                {
                    loader ? <Loader /> : (

                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-header">
                                                <h3 className="card-title">Manage Privacy Policy</h3>
                                            </div>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-12">
                                                        <TextEditor format={policy} setFormat={setPolicy} />
                                                    </div>
                                                </div>
                                                <div className='mt-3 text-center'>
                                                    <button onClick={updatePolicyDetails} className="btn btn btn-naariyal-green w-25">Save Changes</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    )
                }

            </div >

            <Footer />
            <aside className="control-sidebar control-sidebar-dark"></aside>
        </div >
    )
}

export default PrivacyPolicy